import {Client as AuthClient} from '@apps-common/auth';
import {AuthProvider} from '@apps-common/auth-react';
import Alert from '@mui/material/Alert';
import CssBaseline from '@mui/material/CssBaseline';
import Snackbar from '@mui/material/Snackbar';
import {ThemeProvider} from '@mui/material/styles';
import {instanceOf} from 'prop-types';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
} from 'react-router';
import EditPublication from './components/EditPublication.jsx';
import NewPublication from './components/NewPublication.jsx';
import Publication from './components/Publication.jsx';
import Publications from './components/Publications.jsx';
import {GlobalStyles, theme} from './theme.js';

let rootUrl = window.location.origin;
if (import.meta.env.BASE_URL) {
  const url = new URL(import.meta.env.BASE_URL, rootUrl);
  rootUrl = url.href;
}

const authClient = new AuthClient({
  clientId: import.meta.env.VITE_CLIENT_ID,
  redirectUri: rootUrl,
});

function LoginFailure({error}) {
  return (
    <Snackbar open anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
      <Alert severity="error">Login failed: {error.message}</Alert>
    </Snackbar>
  );
}
LoginFailure.propTypes = {
  error: instanceOf(Error).isRequired,
};

function App() {
  const navigate = useNavigate();

  return (
    <AuthProvider client={authClient} navigate={navigate}>
      <Routes>
        <Route path="/" element={<Publications />} />
        <Route path="/new" element={<NewPublication />} />
        <Route path="/publications/:id/edit" element={<EditPublication />} />
        <Route path="/publications/:id" element={<Publication />} />
      </Routes>
    </AuthProvider>
  );
}

const root = createRoot(document.getElementById('root'));

root.render(
  <ThemeProvider theme={theme}>
    <Router basename={import.meta.env.BASE_URL}>
      <CssBaseline />
      <GlobalStyles />
      <App />
    </Router>
  </ThemeProvider>,
);
